/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NetContent
 */
export interface NetContent {
    /**
     * 
     * @type {number}
     * @memberof NetContent
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof NetContent
     */
    unit: NetContentUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof NetContent
     */
    count?: number;
}


/**
 * @export
 */
export const NetContentUnitEnum = {
    G: 'g',
    Kg: 'kg',
    Mg: 'mg',
    Ml: 'ml',
    L: 'l',
    S: 's'
} as const;
export type NetContentUnitEnum = typeof NetContentUnitEnum[keyof typeof NetContentUnitEnum];


/**
 * Check if a given object implements the NetContent interface.
 */
// @ts-ignore
export function instanceOfNetContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "unit" in value;

    return isInstance;
}

// @ts-ignore
export function NetContentFromJSON(json: any): NetContent {
    return NetContentFromJSONTyped(json, false);
}

// @ts-ignore
export function NetContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NetContent {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

// @ts-ignore
export function NetContentToJSON(value?: NetContent | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'unit': value.unit,
        'count': value.count,
    };
}

